import { render, staticRenderFns } from "./BasicMannersClasses.vue?vue&type=template&id=cbe59626&scoped=true&"
import script from "./BasicMannersClasses.vue?vue&type=script&lang=js&"
export * from "./BasicMannersClasses.vue?vue&type=script&lang=js&"
import style0 from "./BasicMannersClasses.vue?vue&type=style&index=0&id=cbe59626&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe59626",
  null
  
)

export default component.exports